import { List } from './components'

const PreventiveLog = () => {
  return <List />
}

export default PreventiveLog
